import styled from "styled-components";
import { pxToRem } from "styles/utils";
import {
  ModalCloseButtonBase,
  ModalDividerBase,
  ModalFooterBase,
  ModalHeaderBase,
  ModalOverlayBase,
  ModalSurfaceBase,
} from "../ModalPrimitives";

export const ModalOverlay = styled(ModalOverlayBase)``;

export const ModalContent = styled(ModalSurfaceBase)`
  width: min(100%, ${pxToRem(429)});
`;

export const ModalHeader = styled(ModalHeaderBase)``;
export const Divider = styled(ModalDividerBase)``;
export const CloseButton = styled(ModalCloseButtonBase)``;

export const ModalBody = styled.div`
  p {
    margin: ${({ theme }) => pxToRem(theme.spacing.xxl)};
    color: ${({ theme }) => theme.colors.inkSoft};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
    font-weight: 500;
    line-height: 1.5;
  }
`;

export const ModalFooter = styled(ModalFooterBase)`
  justify-content: space-between;

  button {
    flex: 1;
  }
`;

export const AgreementLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  margin: ${({ theme }) => pxToRem(theme.spacing.lg)} ${({ theme }) => pxToRem(theme.spacing.xxl)};
`;

export const AgreementLink = styled.a`
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.brandDark};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;
